"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOptionTypes = exports.EVehicleFields = exports.EInputTypes = exports.EBuildingBlocks = exports.EPrintTemplates = void 0;
var EPrintTemplates;
(function (EPrintTemplates) {
    /** 'Ankauf eines Gebrauchtwagen' */
    EPrintTemplates["VEHICLE_PURCHASE"] = "vehicle-purchase";
    /** 'Kaufvertrag (Neuwagen)' */
    EPrintTemplates["VEHICLE_CONTRACT"] = "vehicle-contract";
    /** 'Kaufvertrag (Gebrauchtwagen)' */
    EPrintTemplates["VEHICLE_CONTRACT_USED"] = "vehicle-contract-used";
    EPrintTemplates["CUSTOM_TEMPLATE"] = "custom-template";
    EPrintTemplates["PASSWORD_PORTAL"] = "password-portal";
})(EPrintTemplates = exports.EPrintTemplates || (exports.EPrintTemplates = {}));
var EBuildingBlocks;
(function (EBuildingBlocks) {
    /** Horizontal divider */
    EBuildingBlocks["SPACER"] = "SPACER";
    /** Input, a user has to give when creating a template */
    EBuildingBlocks["INPUT"] = "INPUT";
    EBuildingBlocks["TITLE"] = "TITLE";
    /** Pre-defined text block to be printed */
    EBuildingBlocks["TEXT"] = "TEXT";
    EBuildingBlocks["VEHICLE"] = "VEHICLE";
    EBuildingBlocks["VEHICLE_FIELD"] = "VEHICLE_FIELD";
    EBuildingBlocks["CUSTOMER"] = "CUSTOMER";
    EBuildingBlocks["DEALER"] = "DEALER";
    EBuildingBlocks["SIGNATURE"] = "SIGNATURE";
    EBuildingBlocks["PAGE_BREAK"] = "PAGE_BREAK";
    EBuildingBlocks["COLUMN"] = "COLUMN";
    EBuildingBlocks["AUTHOR"] = "AUTHOR";
    EBuildingBlocks["OPTIONS"] = "OPTIONS";
})(EBuildingBlocks = exports.EBuildingBlocks || (exports.EBuildingBlocks = {}));
var EInputTypes;
(function (EInputTypes) {
    EInputTypes["NUMBER"] = "NUMBER";
    EInputTypes["TEXT"] = "TEXT";
    EInputTypes["PERCENTAGE"] = "PERCENTAGE";
    EInputTypes["CURRENCY"] = "CURRENCY";
    EInputTypes["PRICE"] = "PRICE";
    EInputTypes["SELECT"] = "SELECT";
    EInputTypes["DATE"] = "DATE";
})(EInputTypes = exports.EInputTypes || (exports.EInputTypes = {}));
var EVehicleFields;
(function (EVehicleFields) {
    EVehicleFields["TYPE"] = "TYPE";
    EVehicleFields["SELLER"] = "SELLER";
})(EVehicleFields = exports.EVehicleFields || (exports.EVehicleFields = {}));
var EOptionTypes;
(function (EOptionTypes) {
    EOptionTypes["SERIES"] = "SERIES";
    EOptionTypes["ADDITIONAL"] = "ADDTIONAL";
    EOptionTypes["CUSTOM"] = "CUSTOM";
})(EOptionTypes = exports.EOptionTypes || (exports.EOptionTypes = {}));
